import React, { useContext, useEffect, useState } from 'react';
import { ToastContext } from 'app/context/ToastContext';
import { Divider } from 'primereact/divider';
import './contract-page.css';
import { ProgressSpinner } from 'primereact/progressspinner';
import axios from 'axios';
import { TabPanel, TabView } from 'primereact/tabview';

const cellLabelStyle = {
  width: '30%',
  backgroundColor: '#f5f5f5',
  verticalAlign: 'middle',
  fontWeight: 'bold',
  color: '#555',
  padding: '0.75rem',
};

const cellValueStyle = {
  backgroundColor: '#f9f9f9',
  verticalAlign: 'middle',
  color: '#444',
  padding: '0.75rem',
};

export const AccountPage = () => {
  const { showSuccess, showError } = useContext(ToastContext);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get('/api/account/client-info')
      .then(r => {
        setData(r.data);
      })
      .catch(e => {
        console.error(e);
        showError('Chyba', e.response?.data?.detail);
      })
      .finally(() => setLoading(false));
  }, []);

  const formatFrequencyId = stav => {
    if (!stav) return '';

    if (stav === 1) {
      return 'Jednorázovo';
    } else if (stav === 2) {
      return 'Mesačne';
    } else if (stav === 3) {
      return 'Štvrťročne';
    } else if (stav === 4) {
      return 'Polročne';
    } else if (stav === 5) {
      return 'Ročne';
    }

    return '';
  };
  const formatUhradaPoplatku = uhrada => {
    if (!uhrada) return '';

    if (uhrada === 1) {
      return 'Vopred';
    } else if (uhrada === 2) {
      return 'Postupne';
    }
    return '';
  };

  const getContractName = contract => {
    if (contract.contractNr) {
      return contract.contractNr;
    } else if (contract.proposalNr) {
      return contract.proposalNr;
    }
  };

  return (
    <div>
      <h1 style={{ color: 'var(--primary-color)' }}>ÚČET</h1>

      <Divider className="client-divider" />
      {loading && (
        <div className="flex justify-content-center">
          <ProgressSpinner />
        </div>
      )}
      {!loading && data && (
        <>
          <div className="mb-4 contract-detail" style={{ border: `1px solid 'var(--primary-color)'` }}>
            <TabView>
              {data?.map((contract, index) => (
                <TabPanel header={`Zmluva (${getContractName(contract)})`} key={index}>
                  <div style={{ backgroundColor: 'var(--primary-color)', padding: '0.5rem' }}>
                    <h5 className="mb-0 text-white">ÚČET</h5>
                  </div>
                  <table className="table mb-0" style={{ tableLayout: 'fixed' }}>
                    <tbody>
                      <tr>
                        <td style={cellLabelStyle}>celková suma členského vkladu</td>
                        <td style={cellValueStyle}>{contract.totalSum} EUR</td>
                      </tr>
                      <tr>
                        <td style={cellLabelStyle}>Interval platby</td>
                        <td style={cellValueStyle}>{formatFrequencyId(contract.frequencyId)}</td>
                      </tr>
                      <tr>
                        <td style={cellLabelStyle}>platba za interval</td>
                        <td style={cellValueStyle}>{contract.payment} EUR</td>
                      </tr>
                      <tr>
                        <td style={cellLabelStyle}>poplatok za zradenie účtu</td>
                        <td style={cellValueStyle}>{contract.fee} EUR</td>
                      </tr>
                      <tr>
                        <td style={cellLabelStyle}>úhrada poplatku</td>
                        <td style={cellValueStyle}>{formatUhradaPoplatku(contract.payementPayedId)}</td>
                      </tr>
                      <tr>
                        <td style={cellLabelStyle}>predpokladaný podiel na zisku</td>
                        <td style={cellValueStyle}>{contract.expectedGainInPercent}%</td>
                      </tr>
                      <tr>
                        <td style={cellLabelStyle}>predpokladaná konečná výška podielu na zisku</td>
                        <td style={cellValueStyle}>{contract.expectedTotalGain} EUR</td>
                      </tr>
                      <tr>
                        <td style={cellLabelStyle}>aktuálna hodnota účtu</td>
                        <td style={cellValueStyle}>{contract.currentValueOfAccount} EUR</td>
                      </tr>
                      {/*<tr>*/}
                      {/*  <td style={cellLabelStyle}>aktuálna hodnota vyrovnavacieho podielu</td>*/}
                      {/*  <td style={cellValueStyle}>{contract.currentValueOfVyrovnavaciehoPodielu} EUR</td>*/}
                      {/*</tr>*/}
                    </tbody>
                  </table>
                </TabPanel>
              ))}
            </TabView>
          </div>
        </>
      )}
    </div>
  );
};

export default AccountPage;
